import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#2C3E50] text-white pt-16 pb-8 w-full overflow-hidden">
      <div className="container mx-auto px-4 max-w-[1320px]">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="/assets/img/brand/logo-light.png" 
              alt="Trademark Vector" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-300 mb-4">
              Protecting your brand and intellectual property with expert legal services across the United States.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services/trademark-registration" className="text-gray-300 hover:text-[#C0392B] transition-colors">
                  Trademark Registration
                </Link>
              </li>
              <li>
                <Link to="/services/copyright-registration" className="text-gray-300 hover:text-[#C0392B] transition-colors">
                  Copyright Registration
                </Link>
              </li>
              <li>
                <Link to="/services/company-formation" className="text-gray-300 hover:text-[#C0392B] transition-colors">
                  Company Formation
                </Link>
              </li>
              <li>
                <Link to="/services/trademark-search" className="text-gray-300 hover:text-[#C0392B] transition-colors">
                  Trademark Search
                </Link>
              </li>
              <li>
                <Link to="/services/amazon-brand-registry" className="text-gray-300 hover:text-[#C0392B] transition-colors">
                  Amazon Brand Registry
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#C0392B] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#C0392B] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#C0392B] transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-[#C0392B] transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-[#C0392B] transition-colors">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#C0392B] flex-shrink-0 mt-1" />
                <span className="text-gray-300">765 Market St APT 34D<br />San Francisco, CA 94103</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#C0392B] flex-shrink-0" />
                <a href="tel:+18332017487" className="text-gray-300 hover:text-[#C0392B] transition-colors">
                  +1 (833) 201-7487
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#C0392B] flex-shrink-0" />
                <a href="mailto:info@trademarkvector.com" className="text-gray-300 hover:text-[#C0392B] transition-colors">
                  info@trademarkvector.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} Trademark Vector. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm">
              Designed & Developed with excellence
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;